// export const provinces = [
//   { label: "Buenos Aires (+11)", value: "11" },
//   { label: "CABA (+11)", value: "11" },
//   { label: "Catamarca (+3833)", value: "3833" },
//   { label: "Chaco (+362)", value: "362" },
//   { label: "Chubut (+280)", value: "280" },
//   { label: "Córdoba (+351)", value: "351" },
//   { label: "Corrientes (+379)", value: "379" },
//   { label: "Entre Ríos (+343)", value: "343" },
//   { label: "Formosa (+3717)", value: "3717" },
//   { label: "Jujuy (+388)", value: "388" },
//   { label: "La Pampa (+2954)", value: "2954" },
//   { label: "La Rioja (+3822)", value: "3822" },
//   { label: "Mendoza (+261)", value: "261" },
//   { label: "Misiones (+376)", value: "376" },
//   { label: "Neuquén (+299)", value: "299" },
//   { label: "Río Negro (+2920)", value: "2920" },
//   { label: "Salta (+387)", value: "387" },
//   { label: "San Juan (+264)", value: "264" },
//   { label: "San Luis (+266)", value: "266" },
//   { label: "Santa Cruz (+2966)", value: "2966" },
//   { label: "Santa Fe (+342)", value: "342" },
//   { label: "Santiago del Estero (+385)", value: "385" },
//   { label: "Tierra del Fuego (+2901)", value: "2901" },
//   { label: "Tucumán (+381)", value: "381" },
// ];


export const maxPrefixPhone = 6;
export const maxPhoneNumber = 12;

// module.exports = {
//   provinces,
// };